export default __webpack_public_path__ + "assets/images/e45fe5e965da29a1305b8de2994a46f7.png";